import { listQueryToApiParams } from '#/utils/listUrl/parseListSearchParams';

const COMMA_JOIN_FILTER_CAMEL_KEYS = [
  'invStatus',
  'status',
  'warehouseId',
  'mtrId',
  'mtrStructMainId',
  'mtrStructSubId',
];

const SORT_ID_TO_API = {
  stockNo: 'stock_no',
  mtrNo: 'mtr_no',
  mtrName: 'name',
  invStatus: 'inv_status',
  status: 'status',
};

function mapInventoryStockSort(sort) {
  return (sort ?? []).map((item) => ({
    ...item,
    id: SORT_ID_TO_API[item?.id] ?? item?.id,
  }));
}

export function inventoryStockListQueryToApiParams(listQuery) {
  const filters = { ...(listQuery?.filters || {}) };

  COMMA_JOIN_FILTER_CAMEL_KEYS.forEach((key) => {
    const value = filters[key];
    if (Array.isArray(value) && value.length > 0) {
      filters[key] = value.filter(Boolean).join(',');
    }
  });

  if (Array.isArray(filters.locationId)) {
    const [first] = filters.locationId.filter(Boolean);
    filters.locationId = first ?? undefined;
  }

  return listQueryToApiParams({
    ...listQuery,
    filters,
    sort: mapInventoryStockSort(listQuery?.sort),
  });
}
